/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FailureCode {
  NotFailure = 0,
  UserCreditNotEnough = 1,
  AdminCreditNotEnough = 2,
  PrivateNumberIsInactive = 3,
  PrivateNumberIsExpired = 4,
  UserSendInactive = 5,
  AdminIsInactive = 6,
  PrivateNumberNotValid = 7,
  GroupPriceIsNull = 8,
  SendError = 9,
  SystemIsOutOfService = 11,
  SmsSenderAgentSendTimeNotValid = 12,
  SmsTextIsFilter = 13,
  UserIsExpired = 14,
  AdminIsExpired = 15,
  LinkIsNotAllowed = 16,
  RecipientNotExist = 17,
  ErrorCalculate = 18,
  ErrorSelectNumber = 19,
  ErrorInSaveJob = 20,
  OrganizationIsInactive = 22,
  OrganizationOrHierarchyIsInactive = 23,
  OrganizationNotFound = 25,
  OrganizationCreditNotEnough = 26,
  NotSended = 27,
  OrganizationIsExpired = 28,
  ErrorInAddToRabbit = 29,
  OrganizationSendTimeNotValid = 30,
  OrganizationIsNotAuthenticated = 31,
  DailySendLimit = 32,
  MonthlySendLimit = 33,
  WhiteMessageLimit = 34,
  PrivateNumberIsDeleted = 35,
  SmsSenderAgentIsDeleted = 36,
  AllRecipientIsBlackList = 37,
  CantSendThisTypeWithThisPrivateNumber = 38,
  ParentCreditNotEnoughForSendingSmsBenefit = 39,
  SendVoiceOtpFailed = 40,
  UserNotFound = 41,
  OrganizationOrHierarchySendIsInactive = 42,
  OrganizationHierarchyIsNotAuthenticated = 43,
  ParentOrganizationIsExpired = 44,
  HaveDuplicatedNumbers = 45,
  DescriptionIsEmpty = 46,
  ContradictionBetweenSmsTextCountAndNumberCount = 47,
  ToNumberFieldIsEmpty = 48,
  FileNotFound = 49,
  FileIsEmpty = 50,
  SmartSendLimit = 51,
  SmartSmsRequestDeleted = 52
}
